export const LIST_EDITOR_SHOW  = 'LIST_EDITOR_SHOW';
export const LIST_EDITOR_HIDE  = 'LIST_EDITOR_HIDE';